export default "__VITE_ASSET__B8EuzGsR__"